import { ECalculationType, EOccurrenceType, EPairType, EWithinUnitType } from '@src/emp-3.0/types';

import { EMetricType, TInitialValues } from './types';

export const METRIC_LIST_QUERY_KEY = 'METRIC_LIST_QUERY_KEY';

export const metricTypeOptions = [
  {
    value: EMetricType.TIME_INTERVAL,
    label: 'Time Interval Metric',
  },
  {
    value: EMetricType.SESSIONS,
    label: 'Conversion Metric',
  },
];

export const calculationOptions = [
  {
    value: ECalculationType.CONVERSION_RATE,
    label: 'Conversion Rate',
    type: EMetricType.SESSIONS,
  },
  {
    value: ECalculationType.NUMBER,
    label: 'Number',
    type: EMetricType.SESSIONS,
  },
  {
    value: ECalculationType.AVERAGE,
    label: 'Average Duration',
    type: EMetricType.TIME_INTERVAL,
  },
];

export const withinUnitOptions = [
  {
    value: EWithinUnitType.SECOND,
    label: 'seconds',
  },
  {
    value: EWithinUnitType.MINUTE,
    label: 'minutes',
  },
  {
    value: EWithinUnitType.HOUR,
    label: 'hours',
  },
];

export const pairingLogicOptions = [
  {
    value: EPairType.FIRST_FIRST,
    label: 'First-First Pair',
  },
  {
    value: EPairType.LAST_FIRST,
    label: 'Last-First Pair',
  },
];

export const occurrenceTypeOptions = [
  // { value: EOccurrenceType.SESSIONS, label: 'sessions', type: EMetricType.SESSIONS }, changed due to HP-7844
  // { value: EOccurrenceType.FIRST, label: 'first attempt', type: EMetricType.SESSIONS }, changed due to HP-4723
  { value: EOccurrenceType.MULTIPLE, label: 'attempts', type: EMetricType.SESSIONS },
  { value: EOccurrenceType.FIRST_PAIR, label: 'first pair', type: EMetricType.TIME_INTERVAL },
  {
    value: EOccurrenceType.MULTIPLE_PAIR,
    label: 'multiple pairs',
    type: EMetricType.TIME_INTERVAL,
  },
];

export const defaultInitialValues: TInitialValues = {
  metricType: EMetricType.SESSIONS,
  metricName: null!,
  description: null!,
  calculation: ECalculationType.CONVERSION_RATE,
  firstEvent: null!,
  secondEvent: null!,
  withinRange: null!,
  withinUnit: EWithinUnitType.SECOND,
  pairingLogic: EPairType.FIRST_FIRST,
  occurrenceType: EOccurrenceType.SESSIONS,
  need_distribution: 0,
  distribution: {
    max_value: undefined,
    min_value: undefined,
  },
};

export const INDIVIDUAL_METRIC = 'Individual Metric';
export const METRICS_BY_FLOW = 'Flow';
